import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'

const styles = theme => ({})
export default withStyles(styles)(
  class PricingSelectionComponent extends Component {
    static propTypes = {
      className: PropTypes.string,
      selectedPricing: PropTypes.object.isRequired,
      pricings: PropTypes.array.isRequired,
      onChange: PropTypes.func.isRequired
    }
    static defaultProps = {
      pricings: []
    }
    handleChange = name => e => {
      const { pricings } = this.props
      const key = e.target.value
      const pricing = pricings.find(p => p.key === key)
      this.props.onChange(pricing)
    }
    render() {
      const { className, pricings, selectedPricing } = this.props
      return (
        <FormControl fullWidth={!!className} className={className}>
          <InputLabel htmlFor="pricing-select">Tarif</InputLabel>
          <Select
            value={selectedPricing.key}
            onChange={this.handleChange('pricing')}
            inputProps={{
              name: 'pricing',
              id: 'pricing-select'
            }}>
            {pricings.map(p => (
              <MenuItem key={p.key} value={p.key}>
                {`${p.name} (${p.type === 0 ? 'Tarif Horaire' : 'Tarif Fixe'})`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/pricing/PricingSelectionComponent.js